import { React, ReactRouter, useAPI } from 'mcelroy-lib'
import { FormPage, useToast } from 'mcelroy-components'

/*
    Translation page
*/
export function TranslationPage() {
    const routeParams = ReactRouter.useParams()
    const toast = useToast()
    const navigate = ReactRouter.useNavigate()
    const lang = routeParams.lang
    const key = routeParams.key

    // API translation info query
    const { loading, data, error } = useAPI(`
        query($lang: String, $key: String){
            translation(lang: $lang, key: $key)
        }
    `, { lang: lang, key: key })

    // API update translation mutation
    const { run: updateTranslation } = useAPI(`
        mutation($lang: String!, $key: String!, $val: String!){
            updateTranslation( lang:$lang, key:$key, value:$val )
        }
    `)

    if (loading)
        return null
    else if (error)
        return <div>Not authorized</div>

    // Form fields
    const fields = [
        {
            label: 'Language', disabled: lang != null, name: 'lang', value: lang
        },
        {
            label: 'Key', disabled: key != null, name: 'key', value: key
        },
        {
            label: 'Value', name: 'val', value: data?.translation
        }
    ]

    // Form buttons
    const buttons = [
        {
            label: 'Save',
            primary: true,
            onClick: async (formData) => {
                try {
                    await updateTranslation(formData)
                    toast.success('Translation saved')
                    navigate('/localizedResources')
                } catch (err) {
                    if (err)
                        toast.error(err[0]?.message ?? 'Error updating translation.')
                    else
                        toast.error('Error saving translation')
                    console.log(err)
                }
            }
        },
        {
            label: 'Cancel',
            primary: false,
            onClick: async () => {
                navigate('/localizedResources')
            }
        }
    ]   

    // Page display
    return (
        <FormPage title="Translation" size="sm" fields={fields} buttons={buttons}>
        </FormPage>
    )
}
